import { gql } from '@apollo/client';

export const ACTIVATE_INSTAGRAM_RESOURCE_MUTATION = gql`
  mutation ActivateInstagramResource($code: String!, $companyId: Int!, $userId: Int!) {
    activateInstagramResource(code: $code, companyId: $companyId, userId: $userId) {
      success
    }
  }
`;
